// extracted by mini-css-extract-plugin
export default {"custominput":"input_custominput__H5HwI","input-element":"input_input-element__p4glr","inputStyle":"input_inputStyle__-aR0X"};